// Agrupa las reservas de un tour en un día por grupo (un grupo = un vehículo en los privados), en el
// orden en que aparecen, y los numera: Grupo 1, Grupo 2... El número es de ese tour ese día, no del
// grupo para siempre. Una reserva sin grupo es su propio grupo.
export interface GrupoDelDia<T> {
    numero: number
    reservas: T[]
    total: number
}

export default function gruposDelDia<T extends { id: string, group_id?: string | null, price: number | string }>(reservas: T[]): GrupoDelDia<T>[] {
    const grupos: GrupoDelDia<T>[] = []
    const porClave = new Map<string, GrupoDelDia<T>>()
    for (const reserva of reservas) {
        const clave = reserva.group_id ? `g:${reserva.group_id}` : `r:${reserva.id}`
        let grupo = porClave.get(clave)
        if (!grupo) {
            grupo = { numero: grupos.length + 1, reservas: [], total: 0 }
            porClave.set(clave, grupo)
            grupos.push(grupo)
        }
        grupo.reservas.push(reserva)
        grupo.total += Number(reserva.price) || 0
    }
    return grupos
}
